
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartSearch as ObiChartSearchElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-search.js';
 
 
 

 
 export const ObiChartSearch = createComponent({
   react: React,
   tagName: 'obi-chart-search',
   elementClass: ObiChartSearchElement,
   events: {
     
   }
  });
 
 